module.exports = __webpack_public_path__ + "mail-icon-small-9d4fd2050159f395ff7b32b65a1325c8.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/social-medias/mail-icon-small.svg
// module id = 94
// module chunks = 0